<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      app
      color="primary"
      dark
      class="rounded-r-xl"
    >
      <v-list-item v-if="user">
        <v-list-item-avatar>
          <img src="@/assets/starmcu.png" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title mb-2">
            Hi {{ user.firstName }}!
          </v-list-item-title>
          <v-list-item-title>
            <div>
              <v-chip color="white" outlined>
                <v-icon left small>mdi-check-circle-outline</v-icon>
                Signed In
              </v-chip>
            </div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list rounded>
        <v-list-item to="/" router exact>
          <v-list-item-action>
            <v-icon>mdi-monitor-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Dashboard
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" to="/watertank" router exact>
          <v-list-item-action>
            <v-icon>mdi-water-boiler</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Water Tank
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" to="/gauges" router exact>
          <v-list-item-action>
            <v-icon>mdi-gauge</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Gauges
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" to="/preferences" router exact>
          <v-list-item-action>
            <v-icon>fas fa-cogs</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Preferences
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" to="/devices" router exact>
          <v-list-item-action>
            <v-icon>mdi-chip</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Devices
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" to="/test" router exact>
          <v-list-item-action>
            <v-icon>mdi-account-hard-hat</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Test Page
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-if="!user" v-slot:append>
        <v-divider></v-divider>
        <v-list rounded>
          <v-list-item to="/login" router exact>
            <v-list-item-action>
              <v-icon>fas fa-user-astronaut</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Login
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-app-bar fixed app dense color="white" flat class="accent--text">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon color="accent">fas fa-bars</v-icon>
      </v-app-bar-nav-icon>
      <!-- <v-img src="@/assets/logo.png" max-height="30" max-width="30" /> -->
      <!-- <v-toolbar-title class="ml-3">Growing-Up</v-toolbar-title> -->
      <v-spacer></v-spacer>
      <div class="mr-3">
        <strong>
          {{ new Date() | moment("h:mma") }}
        </strong>
        <small class="ml-1">
          {{ new Date() | moment("MMMM Do, YYYY") }}
        </small>
      </div>

      <v-menu left bottom offset-y v-if="user">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" small class="ml-2">
            <v-icon color="accent" x-small>fas fa-ellipsis-v</v-icon>
          </v-btn>
        </template>

        <v-list class="pa-1">
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",

  components: {},

  data() {
    return {
      drawer: false,
      title: "Vuetify.js",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    logout() {
      this.$store.dispatch("signOutAction").then(() => {
        if (!this.$store.getters.error) {
          this.$router.push("/login");
        }
      });
    },
  },
};
</script>
